import { render } from "./OrderDetail.vue?vue&type=template&id=de84249a&scoped=true&bindings={\"handleCancelOrder\":\"setup\",\"handleConfirmOrder\":\"setup\",\"showPayFn\":\"setup\",\"handlePayOrder\":\"setup\",\"close\":\"setup\"}"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"

import "./OrderDetail.vue?vue&type=style&index=0&id=de84249a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-de84249a"

export default script